import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=29329c34&scoped=true&"
import script from "./MobileFooter.vue?vue&type=script&lang=js&"
export * from "./MobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=29329c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29329c34",
  null
  
)

export default component.exports